import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { yupResolver } from "@hookform/resolvers/yup";
import { Checkbox, PrimaryButton } from "common";
import dayjs from "dayjs";
import { AddPropertyInformation } from "pages/client/AddPropertyPage/AddPropertyInformation";
import { clientSelectors } from "store/client-slice/selectors";
import { ownerPortalPropertySelector } from "store/owner-portal-property-slice/selectors";
import { ownerPortalPropertyActions } from "store/owner-portal-property-slice/slice";
import { isLoading } from "utils/constants";
import { addPropertyStep1Schema } from "validations/addPropertyStep1Schema";

import { Properties } from "components/Properties";

import * as S from "./styled";

export const Step1 = () => {
  const { properties, signupStatus } = useSelector(ownerPortalPropertySelector);
  const { account } = useSelector(clientSelectors);

  const owner_id = account?.id;

  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(addPropertyStep1Schema),
  });

  const onSubmit = () => {
    const body = {
      first_name: account.firstName,
      last_name: account.lastName,
      email: account.email,
      phone_number: account.phoneNumber,
      sign_up_date: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      display_clients: 1,
      sign_up_step_number: 1,
    };
    dispatch(ownerPortalPropertyActions.updateOwner({ body, id: owner_id }));
    dispatch(ownerPortalPropertyActions.resetErrorMessages());
  };

  const handleBackClick = (e) => {
    reset();
    e.preventDefault();
    dispatch(ownerPortalPropertyActions.changeStep(0));
    dispatch(ownerPortalPropertyActions.resetErrorMessages());
  };

  return (
    <>
      <AddPropertyInformation />
      <S.Form className="flex w-full flex-col gap-4" onSubmit={handleSubmit(onSubmit)}>
        {!!properties.length && (
          <>
            <S.Box>
              <S.PropertyTitle>Your Properties</S.PropertyTitle>
              <S.PropertyDescription>You are adding following properties:</S.PropertyDescription>
              <S.Box>
                <Properties
                  isDelete
                  properties={properties}
                  toggleAcceptModal={(deletePropertyKey, id, owner_id) =>
                    dispatch(ownerPortalPropertyActions.toggleAcceptModal({ deletePropertyKey, id, owner_id }))
                  }
                />
              </S.Box>
              <S.Box>
                <Checkbox
                  description="This is residental property"
                  error={errors.firstCheckbox}
                  id="this is residental property"
                  register={register("firstCheckbox")}
                />
              </S.Box>
              <S.Box>
                <Checkbox
                  description={`I confirm I understand that I am adding ${
                    properties.length === 1 ? "this property" : "these properties"
                  } to have my property taxes protested in ${new Date().getFullYear()}`}
                  error={errors.secondCheckbox}
                  id="i confirm i understand that"
                  register={register("secondCheckbox")}
                />
              </S.Box>
            </S.Box>
          </>
        )}
        {properties.length < 1 ? null : (
          <S.ButtonsContainer>
            <PrimaryButton label="continue" loading={isLoading(signupStatus)} minwidth={200} />
            <PrimaryButton eventHandler={handleBackClick} label="back" mode="gray" />
          </S.ButtonsContainer>
        )}
      </S.Form>
    </>
  );
};
